import { Button, Input, Modal } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

const VERSION_UPLOAD_MODAL_TITLE = 'Upload New Version';

const PropertyModal = styled(Modal)`
    .last-form-item {
        margin-bottom: 0px;
    }
`;

const FileInput = styled.span`
    width: 100%;
    display: flex;
    justify-content: left;
    flex-wrap: nowrap;
    margin-bottom: 10px;
`;

const FileNameInput = styled(Input)`
    flex-grow: 1;
`;

const UploadElement = styled.input`
    display: none;
    width: 100px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: white;
`;

function UploadVersionModal() {
    const uploadManager = store.animation?.assets.uploadManager;
    const uploadInputElement = useRef<HTMLInputElement>(null);

    const { modalVisible, file, fileName, loading, isUpdate } =
        uploadManager || {};

    useEffect(() => {
        if (!modalVisible && uploadInputElement.current) {
            uploadInputElement.current.value = '';
        }
    }, [modalVisible]);

    const handleCancel = () => {
        void uploadManager?.hideModalAndReset();
    };

    const disableConfirm = !file;

    return (
        <PropertyModal
            title={VERSION_UPLOAD_MODAL_TITLE}
            open={modalVisible}
            confirmLoading={loading}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button
                    disabled={disableConfirm}
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={() => uploadManager?.upload()}
                >
                    {isUpdate ? 'Update' : 'Upload'}
                </Button>,
            ]}
        >
            <UploadElement
                type="file"
                className="file-select"
                accept=".json"
                ref={uploadInputElement}
                onChange={(e) => {
                    if (
                        uploadManager &&
                        e.target.files &&
                        e.target.files.length === 1
                    ) {
                        uploadManager.file = e.target.files[0];
                    }
                }}
            />
            <FileInput>
                <FileNameInput
                    placeholder="Select a file from your computer"
                    disabled
                    value={fileName}
                />
                <Button
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                        uploadInputElement.current?.click();
                    }}
                >
                    Browse
                </Button>
            </FileInput>
        </PropertyModal>
    );
}

export default observer(UploadVersionModal);
